import NextLink from 'next/link';

import Warning from '@/icons/duotone/warning-circle-green.svg';

import type { FunctionComponent } from 'react';
import type { TypeAlertProps } from './types';

export const Alert: FunctionComponent<TypeAlertProps> = ({
  className = '',
  link,
}: TypeAlertProps) => (
  <div
    className={`rounded-custom border-secondary-500 bg-secondary-50 flex flex-row items-center gap-x-2 border py-4 pr-2 pl-4 ${className} `}
  >
    <Warning className="shrink-0" width={32} height={32} />
    <p className="text-body text-body-m text-primary-900 font-normal">
      Esta vivienda está ocupada parcialmente los próximos meses{' '}
      <NextLink
        href={link}
        prefetch={false}
        className="text-body text-body-m text-primary-500 font-bold"
      >
        Consultar disponibilidad
      </NextLink>
    </p>
  </div>
);

Alert.displayName = 'Alert';
